angular.module('impactx.approval').controller('ApprovalOverviewDialogCtrl', [
    'dataGen',
    '$mdDialog',
    'TranslationService',
    ApprovalOverviewDialogController
]);

function ApprovalOverviewDialogController(dataGen, $mdDialog, TranslationService) {
    var self = this;
    self.trns = {
        abort: TranslationService.get('abort')
    };

    getDataByPosition();

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.retrieveData = function () {
        if (self.data.sortOrder.setId == 2) {
            getDataByRule();
        }
        else {
            getDataByPosition();
        }
    };

    function getDataByPosition() {
        return dataGen.getData({}, {prhId: self.prhId, dehId: self.dehId}, "/approval/overview/position").then(handleResponse);
    }

    function getDataByRule() {
        return dataGen.getData({}, {prhId: self.prhId, dehId: self.dehId}, "/approval/overview/rule").then(handleResponse);
    }

    function handleResponse(response) {
        if (response.data) {
            self.data = response.data;
            angular.extend(self.trns, response.trns);
        }
        if(!self.trns)
        {
            self.trns = response.trns;
        }
    }
}